import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-modal',
    imports: [CommonModule],
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
    animations: [
        trigger('backdropAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('150ms ease-in', style({ opacity: .75 })),
            ]),
            transition(':leave', [
                style({ opacity: .75 }),
                animate('150ms ease-out', style({ opacity: 0 })),
            ]),
        ]),
        trigger('contentAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-50%)' }),
                animate('150ms ease-in', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'translateY(0)' }),
                animate('150ms ease-out', style({ opacity: 0, transform: 'translateY(-50%)' })),
            ]),
        ]),
    ],
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() show = false;
    @Input() size = 'md';
    @Input() closeable = true;

    @Output() close = new EventEmitter<void>();

    ngOnInit() {
        document.addEventListener('keydown', this.closeOnEscape);
    }

    ngOnDestroy() {
        document.removeEventListener('keydown', this.closeOnEscape);
        document.body.style.removeProperty('overflow');
    }

    closeOnEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape' && this.show) {
            this.closeModal();
        }
    };

    closeModal() {
        if (this.closeable) {
            this.close.emit();
        }
    }

    getMaxWidthClass(): string {
        const sizeClasses: Record<string, string> = {
            'xs': 'sm:max-w-xs',
            'sm': 'sm:max-w-sm',
            'md': 'sm:max-w-md',
            'lg': 'sm:max-w-lg',
            'xl': 'sm:max-w-xl',
            '2xl': 'sm:max-w-2xl',
            '3xl': 'sm:max-w-3xl',
            '4xl': 'sm:max-w-4xl',
            '5xl': 'sm:max-w-5xl',
            '6xl': 'sm:max-w-6xl',
            '7xl': 'sm:max-w-7xl',
            'full': 'sm:max-w-full h-full',
        };

        return sizeClasses[this.size] || sizeClasses['md'];
    }

}
